import React, { useCallback, useRef } from "react";
import { Checkbox } from "../../common/UIComponents";
import { getAvailableLegs, getRowCheckState } from "./legSelectionStore";
import { useLegSelection } from "./LegSelectionContext";
import { useRowLegs } from "./useLegStore";

const RowLegCheckboxCellInner = ({ order, rowIndex }) => {
  const { onRowToggle, isLegWise } = useLegSelection();
  const orderId = order?.id;
  const rowLegs = useRowLegs(orderId);
  // onClick (MouseEvent) carries shiftKey reliably; onChange (input event) may not. Stash it for handleChange.
  const shiftRef = useRef(false);

  const available = getAvailableLegs(order);
  const state = getRowCheckState(available, rowLegs);
  const disabled = !isLegWise || state === "disabled" || order?.account_limit_exceeded === true;

  const handleChange = useCallback(
    (e) => {
      e.domEvent?.stopPropagation?.();
      onRowToggle(orderId, available, { shiftKey: shiftRef.current, rowIndex });
      shiftRef.current = false;
    },
    [onRowToggle, orderId, available, rowIndex]
  );

  return (
    <Checkbox
      checked={state === "checked"}
      indeterminate={state === "indeterminate"}
      disabled={disabled}
      onChange={handleChange}
      onClick={(e) => {
        shiftRef.current = e.shiftKey;
        e.stopPropagation();
      }}
    />
  );
};

const RowLegCheckboxCell = React.memo(
  RowLegCheckboxCellInner,
  (prev, next) =>
    prev.order?.id === next.order?.id &&
    prev.order?.account_limit_exceeded === next.order?.account_limit_exceeded &&
    prev.rowIndex === next.rowIndex
);

export default RowLegCheckboxCell;
